import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants/index';
import H3 from 'components/Primatives/H3';
import H1 from 'components/Primatives/H1';



/*

Props:

*/

const OuterDiv = styled.div`

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: ${constants.text.baseFontStyles.fontFamily};
    color: white;
    font-size: 3em;
    margin-bottom: 75px;
    margin-top: ${props => (props.marginTop) ? props.marginTop : '-200'}px;

`;
// const H1 = styled.h1`

//     margin: 0px;

//     @media (max-width: 600px){
//         font-size: 50px;
//     }
// `;

// const H3 = styled.h3`
//      font-family: ${constants.font.primary};
//     margin: 0px;
//     font-size: 35px;
//     font-weight: lighter;

//     @media (max-width: 600px){
//        font-size: 20px;
//     }
// `;


const TagLine = ({ style, onClick, children, ...rest }) => (
    <OuterDiv style = {style}  onClick = {onClick} {...rest} >
        <H1 light center style={{marginBottom: 0}}>Your Health</H1>
        <H3 light center style={{marginTop: 10}}>Anytime • Anywhere</H3>
        { children }
    </OuterDiv>
)



export default TagLine

// color: ${props => (props.color) ? props.color : 'red'};
//   box-shadow: -7px 11px 78px -24px rgba(0,0,0,0.16);


// WEBPACK FOOTER //
// ./src/js/components/Logo/TagLine.jsx